module.exports = __webpack_public_path__ + "img/LUCKY_LIONS_03.be8778e7.jpg";